import i18n from 'modules/core/lib/i18n'

import { NpsVisibilityConfig, NpsWidgetVariant } from './types'

type ProductFamilies = 'talent' | 'finance' | 'time' | 'core'
const VARIANTS: Record<ProductFamilies, NpsWidgetVariant> = {
  talent: 'radical',
  core: 'tangerine',
  finance: 'viridian',
  time: 'champagne',
}

export const getNpsVisibility: NpsVisibilityConfig = (navigation) => ({
  factorial: {
    icon: 'logo-avatar',
    variant: 'radical',
    routes: [
      navigation.dashboard.fullPath(),
      navigation.discover.productUpdates.fullPath(),
      navigation.discover.marketplaceModules.fullPath(),
      navigation.discover.marketplace.fullPath(),
      navigation.inbox.fullPath(),
      navigation.profile.fullPath(),
    ],
    productName: i18n.t('common.company_name'),
  },
  ats: {
    icon: 'user-search',
    variant: VARIANTS.talent,
    routes: [navigation.ats.fullPath()],
    productName: i18n.t('sidebar.recruitment'),
  },
  documents: {
    icon: 'documents',
    variant: VARIANTS.core,
    routes: [navigation.documents.fullPath(), navigation.files.fullPath()],
    productName: i18n.t('sidebar.documents'),
  },
  analytics: {
    icon: 'analytics-graph',
    variant: VARIANTS.core,
    routes: [navigation.analytics.fullPath()],
    productName: i18n.t('sidebar.analytics'),
  },
  time_tracking: {
    icon: 'time-tracking',
    variant: VARIANTS.time,
    routes: [navigation.timeTracking.fullPath()],
    productName: i18n.t('sidebar.time_tracking'),
  },
  timeoff: {
    icon: 'time-off',
    variant: VARIANTS.time,
    routes: [navigation.timeOff.fullPath(), navigation.calendar.fullPath()],
    productName: i18n.t('sidebar.time_off'),
  },
  shift_management: {
    icon: 'time-planning',
    variant: VARIANTS.time,
    routes: [navigation.shifts.fullPath()],
    productName: i18n.t('sidebar.shift_management'),
  },
  payroll: {
    icon: 'payroll-process',
    variant: VARIANTS.time,
    routes: [navigation.payrollBundle.fullPath(), navigation.myPayroll.fullPath()],
    productName: i18n.t('sidebar.payroll_bundle'),
  },
  projects: {
    icon: 'suitcase',
    variant: VARIANTS.finance,
    routes: [navigation.projects.fullPath(), navigation.myProjects.fullPath()],
    productName: i18n.t('sidebar.projects_management'),
  },
  procurement: {
    icon: 'money-bag',
    variant: VARIANTS.finance,
    routes: [navigation.finance.spending.procurement.fullPath(), navigation.myPurchases.fullPath()],
    productName: i18n.t('finance.modules.spending.procurement'),
  },
  expenses: {
    icon: 'money-bag',
    variant: VARIANTS.finance,
    routes: [navigation.finance.spending.expenses.fullPath(), navigation.myExpenses.fullPath()],
    productName: i18n.t('sidebar.expenses_v2'),
  },
  trainings: {
    icon: 'window-user',
    variant: VARIANTS.talent,
    routes: [navigation.trainings.fullPath(), navigation.myTrainings.fullPath()],
    productName: i18n.t('sidebar.trainings'),
  },
  review_process: {
    icon: 'performance',
    variant: VARIANTS.talent,
    routes: [
      navigation.performanceProcess.fullPath(),
      navigation.goals.fullPath(),
      navigation.performanceGoals.fullPath(),
    ],
    productName: i18n.t('sidebar.performance_new'),
  },
  software_management: {
    icon: 'floppy-disk',
    variant: VARIANTS.finance,
    routes: [navigation.software.fullPath()],
    productName: i18n.t('sidebar.software_management'),
  },
  benefits: {
    icon: 'gift',
    variant: VARIANTS.time,
    routes: [navigation.benefits.fullPath(), navigation.myBenefits.fullPath()],
    productName: i18n.t('benefits.module_name'),
  },
  compensations: {
    icon: 'money',
    variant: VARIANTS.core,
    routes: [navigation.compensations.fullPath()],
    productName: i18n.t('sidebar.compensation'),
  },
  salary_advance: {
    icon: 'money',
    variant: VARIANTS.core,
    routes: [navigation.salaryAdvance.fullPath()],
    productName: i18n.t('salary_advance.module_name'),
  },
  engagement: {
    icon: 'surveys',
    variant: VARIANTS.talent,
    routes: [navigation.engagement.fullPath()],
    productName: i18n.t('sidebar.engagement'),
  },
  space_control: {
    icon: 'multiple-buildings',
    variant: VARIANTS.talent,
    routes: [navigation.spaceControl.fullPath()],
    productName: i18n.t('sidebar.space_control'),
  },
})
